export default __webpack_public_path__ + "static/media/padel-league-logo.a1577a83.png";